module.exports = __webpack_public_path__ + "img/ic_launcher.6cfcac6c.png";